
import http from '../utils/HttpCommon';

const getAll = (authorization) => {
  return http.get(`/auth/signon`, authorization ? { headers: { Authorization: authorization } } : undefined);
}

const getReverseSignOnToken = () => {
  return http.get(`/auth/reverse-signon`)
}

export default {
  getAll,
  getReverseSignOnToken
};